export default {
  searchPlaceholder: 'Start by entering the field name. Search term must be at least 3 characters long',
  searchTagline: 'Search by adding single or multiple keywords',
  pickDate: 'Date range',
};
